import '.bf{margin-bottom:12px;}.ssr-plugin'
import '.n{position:relative;}.ssr-plugin'
import '.h{width:100%;}.ssr-plugin'
import '.fj{padding:8px;}.ssr-plugin'
import '.k1{border-radius:8px;}.ssr-plugin'
import '.bw{margin-left:auto;}.ssr-plugin'
import '.gk{margin-right:auto;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.fl{padding:4px;}.ssr-plugin'
import '.a3{gap:4px;}.ssr-plugin'
import '.an{border-radius:12px;}.ssr-plugin'
import '.p{position:absolute;}.ssr-plugin'
import '.k2{top:20px;}.ssr-plugin'
import '.k3{right:20px;}.ssr-plugin'
import { useLexicalNodeSelection } from '@lexical/react/useLexicalNodeSelection.js'
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext.js'
import { mergeRegister } from '@lexical/utils'
import {
  $getNodeByKey,
  $getSelection,
  $isDecoratorNode,
  $isNodeSelection,
  CLICK_COMMAND,
  COMMAND_PRIORITY_LOW,
  KEY_BACKSPACE_COMMAND,
  KEY_DELETE_COMMAND,
} from 'lexical'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { styled } from 'inlines'
import { BLUR_COMMAND, COMMAND_PRIORITY_EDITOR } from 'lexical'
import { $isEmbedNode } from './nodes/EmbedNode.js'
import { Button } from '../Button/index.js'
import { AddEmbedModal } from './Toolbar/AddEmbedModal.js'
import { colors } from '../../tokens/colors.js'
import { Separator } from '../Separator/index.js'

export function EmbedComponent({
  html,
  nodeKey,
}: {
  html: string
  nodeKey: string
}) {
  const [editor] = useLexicalComposerContext()
  const [isSelected, setSelected, clearSelection] =
    useLexicalNodeSelection(nodeKey)
  const [hover, setHover] = useState(false)
  const ref = useRef<HTMLDivElement | null>(null)

  const onDelete = useCallback(
    (event: KeyboardEvent) => {
      if (isSelected && $isNodeSelection($getSelection())) {
        event.preventDefault()
        const node = $getNodeByKey(nodeKey)
        if ($isDecoratorNode(node)) {
          node.remove()
        }
      }

      return false
    },
    [isSelected, nodeKey],
  )

  useEffect(() => {
    return mergeRegister(
      editor.registerCommand<MouseEvent>(
        CLICK_COMMAND,
        (event) => {
          if (
            event.target === ref.current ||
            ref.current?.contains(event.target as Node)
          ) {
            clearSelection()
            setSelected(true)
            return true
          }

          return false
        },
        COMMAND_PRIORITY_LOW,
      ),
      editor.registerCommand(
        KEY_DELETE_COMMAND,
        onDelete,
        COMMAND_PRIORITY_LOW,
      ),
      editor.registerCommand(
        KEY_BACKSPACE_COMMAND,
        onDelete,
        COMMAND_PRIORITY_LOW,
      ),
      editor.registerCommand(
        BLUR_COMMAND,
        () => {
          clearSelection()
          return true
        },
        COMMAND_PRIORITY_EDITOR,
      ),
    )
  }, [clearSelection, editor, isSelected, nodeKey, onDelete, setSelected])

  return (
    <div className="bf n"
      onMouseOver={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <div className="h fj k1 bw gk"
        ref={ref}
        style={{
          border: `1px solid ${colors.neutral20Adjusted}`,
          backgroundColor: colors['neutral10Background'],
        }}
        dangerouslySetInnerHTML={{ __html: html }}
      />
      {hover && (
        <div className="a fl a3 an p k2 k3"
          style={{
            border: `1px solid ${colors.neutral20Adjusted}`,
            background: `linear-gradient(${colors.neutral10Background}),
                         linear-gradient(${colors.neutralInverted100})`,}}
        >
          <AddEmbedModal
            onSave={(html) => {
              editor.update(() => {
                const node = $getNodeByKey(nodeKey)

                if ($isEmbedNode(node)) {
                  const writable = node.getWritable()
                  if (html) {
                    writable.__html = html
                  }
                }
              })
            }}
          >
            <Button leadIcon="edit" variant="ghost" size="small">
              Edit
            </Button>
          </AddEmbedModal>
          <Separator
            orientation="vertical"
            variant="line"
            style={{ height: 16 }}
          />
          <Button
            color="red"
            leadIcon="delete"
            variant="ghost"
            size="small"
            onClick={() => {
              editor.update(() => {
                const node = $getNodeByKey(nodeKey)
                node.remove()
              })
            }}
          >
            Remove
          </Button>
        </div>
      )}
    </div>
  )
}
